import { render, staticRenderFns } from "./setBirthday.vue?vue&type=template&id=1962eda8&"
import script from "./setBirthday.vue?vue&type=script&lang=js&"
export * from "./setBirthday.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports